exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".awards-bookmarks-filter-row{margin-bottom:12px}.bookmarks-awards-fit #page-wrapper{min-height:0!important;height:100vh;overflow:hidden}.bookmarks-awards-fit .wrapper-content{padding-bottom:0!important}.bookmarks-awards-fit .wrapper.wrapper-content{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/contract.awards/bookmarks.component.css
// module id = 1208
// module chunks = 0